enum EToastUUID {
	errorFilteringQuests = 'errorFilteringQuests',
	errorFilteringCampaigns = 'errorFilteringCampaigns',
	errorLoadingQuests = 'errorLoadingQuests',
	errorLoadingCampaigns = 'errorLoadingCampaigns',
	errorFetchingQuestDetails = 'errorFetchingQuestDetails',
	errorLoadingInventoryItems = 'errorLoadingInventoryItems',
	errorLoadingWornItems = 'errorLoadingWornItems',
	errorEquippingItem = 'errorEquippingItem',
	errorUnequippingItem = 'errorUnequippingItem',
	errorSavingAvatarType = 'errorSavingAvatarType',
	errorForgingItem = 'errorForgingItem',
	errorConnectingWallet = 'errorConnectingWallet',
	errorGithubAuth = 'errorGithubAuth',
	errorLinkingWallet = 'errorLinkingWallet',
	errorFetchingUserQuiz = 'errorFetchingUserQuiz',
	errorCheckingContractExistence = 'errorCheckingContractExistence',
	errorGettingContractName = 'errorGettingContractName',
	errorPreviewingItems = 'errorPreviewingItems',
	errorOpeningChests = 'errorOpeningChests',
	socketConnectionState = 'socketConnectionState',
	deployContractError = 'deployContractError'
}

export { EToastUUID };
